import { render } from "./ImageLoading.vue?vue&type=template&id=0dd5174e&scoped=true&ts=true"
import script from "./ImageLoading.vue?vue&type=script&lang=ts"
export * from "./ImageLoading.vue?vue&type=script&lang=ts"

import "./ImageLoading.vue?vue&type=style&index=0&id=0dd5174e&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd5174e"]])

export default __exports__